import React, { PureComponent } from 'react'
import { func, string } from 'prop-types'
import { withI18n } from '@active/react-utils/i18n'
import Responsive from '@active/react-utils/components/Responsive'
import Button from '@active/react-ui/Button'
import Link from '@active/react-ui/Link'
import I18nMessage from '../../common/I18nMessage'
import SideTypeList, { KeycloakSideTypeList } from '../SideTypeListConf'
import Logo from './PageLogo.svg'
import './header.scss'
import { getUrlParameter, buildSafeQueryString, getSafeReturnUrl } from '../../../shared/utils/commonUtils'
import connectLocale from '../../../shared/utils/connectLocale'

class Header extends PureComponent {
  static propTypes = {
    i18n: func.isRequired,
    locale: string.isRequired,
    keycloakAPIServerHost: string.isRequired,
    passportAPIServerHost: string.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      isShowMenu: false,
    }
  }

  handleMenu = () => {
    this.setState({
      isShowMenu: true,
    })
  }

  handleClose = () => {
    this.setState({
      isShowMenu: false,
    })
  }

  // eslint-disable-next-line class-methods-use-this
  handleBack = returnUrl => {
    const safeReturnUrl = getSafeReturnUrl(returnUrl)
    if (safeReturnUrl) {
      window.location.replace(safeReturnUrl)
    }
  }

  render() {
    const {
      i18n, locale, passportAPIServerHost, keycloakAPIServerHost,
    } = this.props
    const { isShowMenu } = this.state
    const returnUrl = getSafeReturnUrl(getUrlParameter('returnUrl'))
    // Build safe query string to prevent XSS attacks
    const localeParam = buildSafeQueryString(locale)
    return (
      <div className="passport-ui-app__page-header">
        <Responsive eqAbove="md">
          <div className="passport-ui-app__desktop__page-header">
            <img src={Logo} className="passport-ui-app__desktop__logo" alt="logo" />
            {returnUrl && returnUrl !== 'undefined' && <Button className="back-button" type="primary" size="sm" onClick={() => this.handleBack(returnUrl)}>
              <i style={{ marginRight: '6px', fontWeight: 600, fontSize: '16px' }} className="ic-angle-left-light" />
              {i18n('passport.common.btn.back')}
            </Button>}
          </div>
        </Responsive>
        <Responsive eqAbove="md" not>
          {isShowMenu && (
            <div className="header-aside">
              <span
                onClick={this.handleClose}
                aria-label={i18n('passport.common.btn.close')}
                role="button"
                className="header-aside-close"
                tabIndex="0"
              >
                <i className="ic-cross" />
              </span>
              {SideTypeList.map(type => (
                <Link href={`${passportAPIServerHost}/page/account/${type}${localeParam}`}>
                  <a className="header-aside-nav">
                    <I18nMessage id={`passport.${type}.title`} />
                  </a>
                </Link>
              ))}
              {KeycloakSideTypeList.map(type => (
                <Link href={`${keycloakAPIServerHost}/auth/realms/active/personal/${type}${localeParam}`}>
                  <a className="header-aside-nav">
                    <I18nMessage id={`passport.${type}.title`} />
                  </a>
                </Link>
              ))}
              <div className="header-aside-divider" />
            </div>
          )}
          <div className="header--tablet__topbar">
            <span onClick={this.handleMenu} className="header--tablet__topbar-nav">
              <i className="ic-menu" />
            </span>
            <span className="header--tablet__topbar-logo">
              <img
                src={Logo}
                alt="logo"
              />
            </span>
            {/* <span className="header--tablet__topbar-nav">
              <span className="icon-search-thin hide" />
            </span> */}
            <Button className="back-button" type="primary" size="sm" onClick={() => this.handleBack(returnUrl)}>
              <i style={{ marginRight: '6px', fontWeight: 600, fontSize: '16px' }} className="ic-angle-left-light" />
              {i18n('passport.common.btn.back')}
            </Button>
          </div>
        </Responsive>
      </div>
    )
  }
}

export default withI18n(connectLocale(Header))
